import { CoreDataDictionaryViewsName } from './name';
import { createAddCollectionSyncSlice } from '@sonar-software/xuder';
import { DataDictionaryView } from '@types';
import { getCoreDataDictionaryViewsAsyncSlice } from './get';

export const addCoreDataDictionaryViewsSyncSlice = createAddCollectionSyncSlice({
	add: (view: DataDictionaryView) => view,
	hasRequest: true,
	name: CoreDataDictionaryViewsName,
	state: getCoreDataDictionaryViewsAsyncSlice.asyncState
});
